import _ from 'common-tools/LodashHelper'

export const AppState = (fieldList) => {
  return (state) => {
    let ret = {}
    let fieldListValues = []
    if (_.isArray(fieldList)) {
      fieldListValues = fieldList
    } else {
      fieldListValues.push(fieldList)
    }
    _.forEach(fieldListValues, (f) => {
      if (_.isString(f)) {
        let fieldValue = _.get(state.AppState, f)
        _.set(ret, f, fieldValue)
      }
      if (_.isPlainObject(f)) {
        let fieldValue = _.get(state.AppState, f.sourceProp) || f.defaultValue
        _.set(ret, f.destProp, fieldValue)
      }
      if (_.isFunction(f)) {
        let customValue = f(state.AppState)
        _.set(ret, customValue.prop, customValue.value)
      }
    })
    return ret
  }
}
